import React from "react";
import "../css/Pricing.css";

const Pricing = () => {
  return (
    <div className="pricing">

      {/* ================= HERO ================= */}
      <section className="pr-hero">
        <img 
          src="https://images.pexels.com/photos/6389516/pexels-photo-6389516.jpeg"
          alt="Pricing Hero"
        />
        <div className="pr-hero-text">
          <h1>PRICING</h1>
          <p>Built for athletes who demand more from their training.</p>
        </div>
      </section>


      {/* ================= PLANS ================= */}
      <section className="pr-plans">
        <h2 className="pr-title">Choose Your Mode</h2>

        <div className="plans-grid">

          {/* BASIC */}
          <div className="plan-card">
            <h3>Starter Mode</h3>
            <h4 className="price">$49<span>/mo</span></h4>
            <ul>
              <li>Gym Access</li>
              <li>Basic Equipment Use</li>
              <li>Weekly Check-In</li>
              <li>Starter Conditioning Guide</li>
            </ul>
            <button>Join Now</button>
          </div>

          {/* MOST POPULAR */}
          <div className="plan-card popular">
            <div className="badge">MOST SELECTED</div>
            <h3>Season Mode</h3>
            <h4 className="price">$89<span>/mo</span></h4>
            <ul>
              <li>All Access</li>
              <li>Strength + Conditioning Program</li>
              <li>Monthly Athlete Review</li>
              <li>Mobility Framework Included</li>
            </ul>
            <button>Start Training</button>
          </div>

          {/* ELITE */}
          <div className="plan-card">
            <h3>Elite Mode</h3>
            <h4 className="price">$159<span>/mo</span></h4>
            <ul>
              <li>1-on-1 Coaching Weekly</li>
              <li>Advanced Athlete Analysis</li>
              <li>Custom Macro Plan</li>
              <li>Performance Tracking</li>
            </ul>
            <button>Go Elite</button>
          </div>

        </div>
      </section>



      {/* ================= ADD-ONS ================= */}
      <section className="pr-addons">
        <h2>Enhance Your Training</h2>

        <div className="addons-grid">
          <div className="addon">
            <h3>Mobility Lab</h3>
            <p>Deep-tissue preparation & recovery optimization.</p>
          </div>
          <div className="addon">
            <h3>Nutrition Strategy</h3>
            <p>Structured macros tailored to your season-phase.</p>
          </div>
          <div className="addon">
            <h3>Performance Tests</h3>
            <p>Speed, strength & conditioning baselines.</p>
          </div>
          <div className="addon">
            <h3>Open Gym+</h3>
            <p>Extended hours, exclusive machines & elite rigs.</p>
          </div>
        </div>
      </section>



      {/* ================= COMPARISON GRID ================= */}
      <section className="pr-compare">
        <h2>Compare Plans</h2>
      
        <div className="compare-table">
      
          {/* Desktop Header */}
          <div className="cmp-row header">
            <span></span>
            <span>Starter</span>
            <span>Season</span>
            <span>Elite</span>
          </div>
      
          {/* Row 1 */}
          <div className="cmp-row">
            <span className="feature">Gym Access</span>
      
            {/* Desktop values */}
            <span className="desk-val">✔</span>
            <span className="desk-val">✔</span>
            <span className="desk-val">✔</span>
      
            {/* Mobile values */}
            <div className="mob-val"><strong>Starter:</strong> ✔</div>
            <div className="mob-val"><strong>Season:</strong> ✔</div>
            <div className="mob-val"><strong>Elite:</strong> ✔</div>
          </div>
      
          {/* Row 2 */}
          <div className="cmp-row">
            <span className="feature">Guided Workouts</span>
      
            <span className="desk-val">—</span>
            <span className="desk-val">✔</span>
            <span className="desk-val">✔</span>
      
            <div className="mob-val"><strong>Starter:</strong> —</div>
            <div className="mob-val"><strong>Season:</strong> ✔</div>
            <div className="mob-val"><strong>Elite:</strong> ✔</div>
          </div>
      
          {/* Row 3 */}
          <div className="cmp-row">
            <span className="feature">1-on-1 Coaching</span>
      
            <span className="desk-val">—</span>
            <span className="desk-val">—</span>
            <span className="desk-val">✔</span>
      
            <div className="mob-val"><strong>Starter:</strong> —</div>
            <div className="mob-val"><strong>Season:</strong> —</div>
            <div className="mob-val"><strong>Elite:</strong> ✔</div>
          </div>
      
          {/* Row 4 */}
          <div className="cmp-row">
            <span className="feature">Performance Reports</span>
      
            <span className="desk-val">—</span>
            <span className="desk-val">✔</span>
            <span className="desk-val">✔</span>
      
            <div className="mob-val"><strong>Starter:</strong> —</div>
            <div className="mob-val"><strong>Season:</strong> ✔</div>
            <div className="mob-val"><strong>Elite:</strong> ✔</div>
          </div>
      
          {/* Row 5 */}
          <div className="cmp-row">
            <span className="feature">Nutrition Program</span>
      
            <span className="desk-val">—</span>
            <span className="desk-val">—</span>
            <span className="desk-val">✔</span>
      
            <div className="mob-val"><strong>Starter:</strong> —</div>
            <div className="mob-val"><strong>Season:</strong> —</div>
            <div className="mob-val"><strong>Elite:</strong> ✔</div>
          </div>
      
        </div>
      </section>


      {/* ================= CTA ================= */}
      <section className="pr-cta">
        <h1>ACTIVATE YOUR SEASON</h1>
      </section>

    </div>
  );
};

export default Pricing;
